import { authRoles } from 'app/auth/authRoles'
export const navigations = [
    {
        label: 'Dashboard',
        type: 'label',
        path: '/dashboard',
        role: authRoles.admin,
    },
    {
        name: 'Dashboard',
        path: '/dashboard/default',
        icon: 'dashboard',
        role: authRoles.guest,
    },
    {
        name: 'ตารางข้อมูล',
        path: '/dashboard/data-table',
        icon: 'table',
        role: authRoles.guest,
    },
    /*{
        label: 'การตรวจวินิจฉัย',
        type: 'label',
        path: '/diagnosis',
        role: authRoles.editor
    },
    {
        name: 'การตรวจวินิจฉัย',
        path: '/diagnosis/default',
        icon: 'favorite',
        role: authRoles.editor
    },*/
    {
        label: 'ผู้ดูแลระบบ',
        type: 'label',
        path: '/admin',
        role: authRoles.admin,
    },
    {
        name: 'ตั้งค่าการเชื่อมต่อ',
        path: '/admin/rule',
        icon: 'assignment_ind',
        role: authRoles.admin,
    },
    {
        name: 'ตั้งค่าการแสดงผล',
        path: '/admin/dashboard_setting',
        icon: 'display_settings',
        role: authRoles.admin,
    },
    {
        name: 'ผู้ใช้งานระบบ',
        path: '/admin/user',
        icon: 'person',
        role: authRoles.admin,
    },

    /*{
        name: 'รายงาน',
        path: '/admin/report',
        icon: 'mail',
        role: authRoles.admin
    },{
        name: 'เครื่องวัดความดัน',
        path: '/admin/labolink',
        icon: 'smart_screen',
        role: authRoles.admin
    },*/
]
